import React from 'react';
import { Wrap } from '../../components/index';
import * as _ from 'lodash';

const Location: React.FC = () => {
  return <Wrap>locations</Wrap>;
};

export default Location;
